// removed by extract-text-webpack-plugin
module.exports = {"controller":"controller__CharM","progress":"progress__VheW_","with-transition":"with-transition__1e6yI","controls":"controls__NGyk6","dot":"dot__2g3jK","active":"active__3tdGM","button":"button__c4y9y","previous":"previous__18oci","next":"next__3KvLL"};


//////////////////
// WEBPACK FOOTER
// ./components/raffle/styles/RaffleCarouselController.scss
// module id = 1Hxg
// module chunks = 1